import React, { useContext, useEffect, useState } from "react";
import ContentLayout from "../../component/ContentLayout";
import { AgGridReact } from "ag-grid-react";
import VisibilityIcon from "@mui/icons-material/Visibility";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import axios from "../../util/axios";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Context } from "../../component/Context/ErrorContext";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import CompanyModal from "../../component/CompanyModal";
import Select from "react-select";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const pageSize = 10;

const Companies = () => {
  const { setError } = useContext(Context);
  const navigate = useNavigate();
  const [companyData, setCompanyData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [createUpdateModal, setCreateUpdateModal] = useState({
    action: "",
  });
  const [company, setCompany] = useState({
    id: 0,
    name: "",
    domain: "",
    contact_email: "",
    password: "",
    phone: "",
    address: "",
    latitude: "",
    longitude: "",
    total_amount: "",
    count_of_current_employee: "",
    number_of_current_employee: "",
  });
  const [pricingInputs, setPricingInputs] = useState<Record<number, { selectedAmount: any; customAmount: string }>>({});
  const [pricingLoading, setPricingLoading] = useState<Record<number, boolean>>({});

  const predefinedAmounts = [
    { value: 400, label: "$400" },
    { value: 600, label: "$600" },
    { value: 700, label: "$700" },
    { value: 800, label: "$800" },
  ];
  // Column Definitions: Defines the columns to be displayed.
  const [colDefs] = useState<any>([
    {
      field: "name",
      headerName: "Name",
      minWidth: 250,
      cellRenderer: (param: any) => {
        return (
          <div
            className={"flex items-center gap-2 cursor-pointer"}
            onClick={() => navigate(`/companies/${param?.data?.id}`)}
          >
            <VisibilityIcon />
            <p>{param.value}</p>
          </div>
        );
      },
    },
    {
      field: "contact_email",
      headerName: "Email",
      minWidth: 200,
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center justify-start"}>
            <p>{param.value}</p>
          </div>
        );
      },
    },
    {
      field: "phone",
      headerName: "MOBILE NUMBER",
      minWidth: 150,
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center justify-start"}>
            <p>{param.value}</p>
          </div>
        );
      },
    },
    {
      field: "start_subscription",
      headerName: "DATE",
      minWidth: 100,
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center justify-start"}>
            <p>{moment(param.value).format("MM/DD/YYYY")}</p>
          </div>
        );
      },
    },
    {
      field: "pandadoc_payment_status",
      headerName: "PandaDoc Status",
      minWidth: 150,
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center justify-start"}>
            <p>{param.value || "-"}</p>
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 300,
      flex: 1,
      cellRenderer: (param: any) => {
        const companyId = param?.data?.id;
        const input = pricingInputs[companyId] || { selectedAmount: null, customAmount: "" };
        const isLoading = pricingLoading[companyId] || false;

        return (
          <div className={"h-full flex flex-col gap-2 py-2 min-w-0"}>
            <div className={"flex items-center gap-2 flex-wrap"}>
              <EditIcon
                className={"text-primaryText cursor-pointer hover:opacity-80"}
                titleAccess={"Edit"}
                onClick={() => {
                  setCompany(param?.data);
                  setCreateUpdateModal({
                    action: "Update",
                  });
                }}
              />
              <CloseIcon
                className={"text-red-600 cursor-pointer hover:opacity-80"}
                titleAccess={"Delete"}
                onClick={() => deleteCompany(param?.data?.id)}
              />
            </div>
            <div className={"flex flex-col sm:flex-row items-stretch sm:items-center gap-2 flex-wrap min-w-0"}>
              <div className={"flex-1 min-w-[100px] sm:min-w-[120px] max-w-full"}>
                <Select
                  options={predefinedAmounts}
                  value={input.selectedAmount}
                  onChange={(value) => {
                    setPricingInputs(prev => ({
                      ...prev,
                      [companyId]: { selectedAmount: value, customAmount: "" }
                    }));
                  }}
                  placeholder="Amount"
                  className={"text-xs"}
                  isClearable
                  menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                  menuPosition="fixed"
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "32px",
                      height: "32px",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      height: "32px",
                      padding: "0 8px",
                    }),
                    input: (base) => ({
                      ...base,
                      margin: "0px",
                      fontSize: "12px",
                    }),
                    indicatorsContainer: (base) => ({
                      ...base,
                      height: "32px",
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 99999,
                      maxHeight: "180px",
                    }),
                    menuList: (base) => ({
                      ...base,
                      maxHeight: "180px",
                      overflowY: "auto",
                      padding: "4px 0",
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 99999,
                    }),
                    option: (base) => ({
                      ...base,
                      padding: "6px 12px",
                      fontSize: "12px",
                    }),
                  }}
                />
              </div>
              <input
                type="number"
                value={input.customAmount}
                onChange={(e) => {
                  setPricingInputs(prev => ({
                    ...prev,
                    [companyId]: { selectedAmount: null, customAmount: e.target.value }
                  }));
                }}
                placeholder="Custom $"
                className={
                  "bg-white w-full sm:w-20 rounded-md p-1.5 border border-gray outline-none text-xs min-w-[80px]"
                }
                min="0"
                step="0.01"
              />
              <button
                className={
                  "bg-primary text-white px-3 py-1.5 rounded-md text-xs disabled:cursor-not-allowed disabled:opacity-70 opacity-100 flex items-center justify-center gap-1 whitespace-nowrap w-full sm:w-auto"
                }
                onClick={() => updateCompanyPricing(companyId)}
                disabled={isLoading || (!input.selectedAmount && !input.customAmount)}
              >
                {isLoading ? (
                  <AiOutlineLoading3Quarters className={"animate-spin"} />
                ) : (
                  "Update"
                )}
              </button>
            </div>
          </div>
        );
      },
    },
  ]);


  useEffect(() => {
    fetchCompanyData();
  }, []);

  const fetchCompanyData = async () => {
    setLoading(true);
    axios({
      URL: `/omw/admin/get-company-subscription`,
      method: "GET",
    })
      .then((res: any) => {
        setCompanyData(res?.data?.data);
      })
      .catch((err) => setError(err?.response?.data?.message))
      .finally(() => setLoading(false));
  };

  const createCompanyHandler = () => {
    const payload: any = { ...company };
    if (createUpdateModal.action === "Create") {
      delete payload.id;
      payload.start_subscription = moment().format();
      payload.end_subscription = moment().add(1, "year").format();
    } else {
      if (company?.password === '') {
        delete payload.password;
      }
    }

    setModalLoading(true);
    axios(
      createUpdateModal.action === "Update"
        ? {
          URL: `/omw/admin/update-company-subscription/${company?.id}`,
          method: "PATCH",
          data: { ...payload },
        }
        : {
          URL: "/omw/admin/create-company-subscription",
          method: "POST",
          data: {
            ...payload,
          },
        }
    )
      .then((res: any) => {
        if (res.data) {
          fetchCompanyData();
          setModalLoading(false);
          setCompany({
            id: 0,
            name: "",
            domain: "",
            contact_email: "",
            password: "",
            phone: "",
            address: "",
            latitude: "",
            longitude: "",
            total_amount: "",
            count_of_current_employee: "",
            number_of_current_employee: "",
          });
          setCreateUpdateModal({ action: "" });
        }
      })
      .catch((err) => {
        setError(err.response?.data?.message);
      })
      .finally(() => setModalLoading(false));
  };

  const deleteCompany = (id: any) => {
    axios({
      URL: `/omw/admin/delete-company-subscription/${id}`,
      method: "DELETE",
    })
      .then((res: any) => {
        if (res.data) {
          fetchCompanyData();
        }
      })
      .catch((err: any) => {
        setError(err.response?.data?.message)
      });
  };

  const updateCompanyPricing = async (companyId: number) => {
    const input = pricingInputs[companyId] || { selectedAmount: null, customAmount: "" };
    const amount = input.selectedAmount?.value || parseFloat(input.customAmount);
    
    if (!amount || amount <= 0) {
      setError("Please select or enter a valid amount");
      return;
    }

    setPricingLoading(prev => ({ ...prev, [companyId]: true }));
    await axios({
      URL: `/omw/admin/update-company-pricing/${companyId}`,
      method: "PUT",
      data: { amount },
    })
      .then((res: any) => {
        fetchCompanyData();
        setPricingInputs(prev => ({
          ...prev,
          [companyId]: { selectedAmount: null, customAmount: "" }
        }));
        setError("");
      })
      .catch((err) => {
        setError(err.response?.data?.message);
      })
      .finally(() => {
        setPricingLoading(prev => ({ ...prev, [companyId]: false }));
      });
  };

  return (
    <ContentLayout className={"items-start"}>
      <p className={"text-3xl font-bold text-secondary"}>Companies</p>
      <div className={"mt-4 w-full h-auto bg-white p-2"}>
        <div className={"flex w-full justify-end my-3 px-3"}>
          <button
            className={
              "flex items-center justify-center bg-primary text-white px-8 py-2 rounded-md sm:w-auto w-full"
            }
            onClick={() =>
              setCreateUpdateModal({
                action: "Create",
              })
            }
          >
            Create Company
          </button>
        </div>
        <div className="ag-theme-quartz w-full" style={{ height: 500 }}>
          <AgGridReact
            loading={loading}
            rowData={companyData}
            defaultColDef={{
              flex: 10,
            }}
            columnDefs={colDefs}
            pagination={true}
            paginationPageSize={pageSize}
            paginationPageSizeSelector={[10, 25, 50, 100]}
          />
        </div>
      </div>
      <CompanyModal
        open={createUpdateModal.action}
        onClose={() => setCreateUpdateModal({ action: "" })}
        company={company}
        setCompany={setCompany}
        onSubmit={createCompanyHandler}
        loading={modalLoading}
      />
    </ContentLayout>
  );
};

export default Companies;
